<template>
    <div class="teacher-box">
        <SearchTop v-if="teacherIntroView" :resultCount="resultCount" @searchChange="defaultParmasChange"></SearchTop>
        <RecommendTeachers v-if="teacherIntroView" :teacherList="teacherList" ></RecommendTeachers>
        <div v-if="teacherIntroView" class="view-more">
            <el-button>VIEW MORE COURSES</el-button>
        </div>
        <TeacherInfo v-if="!teacherIntroView"></TeacherInfo>
    </div>
</template>

<script>

import RecommendTeachers from "./Component/RecommendTeachers";
import SearchTop from "./Component/SearchTop";
import TeacherInfo from "./Component/TeacherInfo";
import { mapState } from "vuex";
export default {
    computed: {
        ...mapState({
            userInfo: (state) => state.app.userInfo,
            schoolId: (state) => state.app.schoolId,
        }),
    },
    components: {
        RecommendTeachers,
        SearchTop,
        TeacherInfo
    },
    data() {
        return {
            teacherList:[],
            defaultParmas:{
                page:1,
                limit:16,
            },
            resultCount:'0 teachers',
            teacherIntroView:false,
        }
    },
    watch:{
        '$route.query':function(newVal,oldVal){
            this.initPage();
        },
        'schoolId':function(newVal,oldVal){
            this.getMoreTeachers();
        }
    },
    created(){
        this.initPage();
    },
    methods: {
        //如果url内有teacherId进来，去导师简介页面
        initPage(){
            if(this.$route.query&&this.$route.query.teacherId){
                this.teacherIntroView = false;
            }else{
                this.teacherIntroView = true;
                this.getMoreTeachers();
            }
        },
        defaultParmasChange(data){
            this.defaultParmas = Object.assign({},this.defaultParmas,data);
            this.getMoreTeachers();
        },
        getMoreTeachers(){
            let params = {...this.defaultParmas};
            params.schoolId = this.schoolId;
            params.searchteacher = params.queryStr;
            delete params.queryStr;
            this.$api.courseApi.getMoreTeachers(params).then(res=>{
                if (res.status === "0") {
                    this.teacherList = res.data.rows;
                }
            });
            
        },
    }
}
</script>

<style scoped lang="scss">
@import "~@/utils/vw.scss";
.teacher-box {
    // background: #f0f2f5;
    // padding: 16px 0 0;

    .view-more {
        margin: vw(40) 0 0 0;
        padding: 0 0 vw(96) 0;
        text-align: center;
        .el-button {
            width: vw(312);
            height: vw(48);
            background: #f48c06;
            border-radius: 32px;
            color: #ffffff;
            line-height: vw(20);
            font-weight: 600;
            font-size: vw(20);
            border: none;
        }
    }
}
</style>